"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _Option = _interopRequireDefault(require("./Option"));

var _Icons = _interopRequireDefault(require("./Icons"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var groupsHaveOptions = function groupsHaveOptions(options) {
  return options !== null && options !== void 0 && options[0].options ? options.some(function (groupOption) {
    var _groupOption$options;

    return ((_groupOption$options = groupOption.options) === null || _groupOption$options === void 0 ? void 0 : _groupOption$options.length) > 0;
  }) : true;
};

var Listbox = function Listbox(_ref) {
  var id = _ref.id,
      currentValue = _ref.currentValue,
      options = _ref.options,
      visualFocusIndex = _ref.visualFocusIndex,
      lastOptionIndex = _ref.lastOptionIndex,
      multiple = _ref.multiple,
      optional = _ref.optional,
      optionalItem = _ref.optionalItem,
      searchable = _ref.searchable,
      handleOptionOnClick = _ref.handleOptionOnClick,
      getSelectWidth = _ref.getSelectWidth;
  var colorsTheme = (0, _useTheme["default"])();
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  var listboxRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      styles = _useState2[0],
      setStyles = _useState2[1];

  var globalIndex = optional && !multiple ? 0 : -1; // index for options, starting from 0 to options.length -1

  var mapOptionFunc = function mapOptionFunc(option, mapIndex) {
    if (option.options) {
      var groupId = "group-".concat(mapIndex);
      return option.options.length > 0 && /*#__PURE__*/_react["default"].createElement("li", {
        key: "group-".concat(mapIndex)
      }, /*#__PURE__*/_react["default"].createElement(GroupList, {
        role: "group",
        "aria-labelledby": groupId
      }, /*#__PURE__*/_react["default"].createElement(GroupLabel, {
        role: "presentation",
        id: groupId
      }, option.label), option.options.map(function (singleOption) {
        globalIndex++;
        return /*#__PURE__*/_react["default"].createElement(_Option["default"], {
          key: "option-".concat(singleOption.value),
          id: "option-".concat(globalIndex),
          option: singleOption,
          onClick: handleOptionOnClick,
          multiple: multiple,
          visualFocused: visualFocusIndex === globalIndex,
          isGroupedOption: true,
          isLastOption: lastOptionIndex === globalIndex,
          isSelected: multiple ? currentValue.includes(singleOption.value) : currentValue === singleOption.value
        });
      })));
    } else {
      globalIndex++;
      return /*#__PURE__*/_react["default"].createElement(_Option["default"], {
        key: "option-".concat(option.value),
        id: "option-".concat(globalIndex),
        option: option,
        onClick: handleOptionOnClick,
        multiple: multiple,
        visualFocused: visualFocusIndex === globalIndex,
        isLastOption: lastOptionIndex === globalIndex,
        isSelected: multiple ? currentValue.includes(option.value) : currentValue === option.value
      });
    }
  };

  (0, _react.useLayoutEffect)(function () {
    if (currentValue && !multiple) {
      var _listEl$scrollTo;

      var listEl = listboxRef === null || listboxRef === void 0 ? void 0 : listboxRef.current;
      var selectedListOptionEl = listEl === null || listEl === void 0 ? void 0 : listEl.querySelector("[aria-selected='true']");
      listEl === null || listEl === void 0 ? void 0 : (_listEl$scrollTo = listEl.scrollTo) === null || _listEl$scrollTo === void 0 ? void 0 : _listEl$scrollTo.call(listEl, {
        top: (selectedListOptionEl === null || selectedListOptionEl === void 0 ? void 0 : selectedListOptionEl.offsetTop) - (listEl === null || listEl === void 0 ? void 0 : listEl.clientHeight) / 2
      });
    }
  }, [currentValue, multiple]);
  (0, _react.useLayoutEffect)(function () {
    var _listboxRef$current, _visualFocusedOptionE;

    var visualFocusedOptionEl = listboxRef === null || listboxRef === void 0 ? void 0 : (_listboxRef$current = listboxRef.current) === null || _listboxRef$current === void 0 ? void 0 : _listboxRef$current.querySelectorAll("[role='option']")[visualFocusIndex];
    visualFocusedOptionEl === null || visualFocusedOptionEl === void 0 ? void 0 : (_visualFocusedOptionE = visualFocusedOptionEl.scrollIntoView) === null || _visualFocusedOptionE === void 0 ? void 0 : _visualFocusedOptionE.call(visualFocusedOptionEl, {
      block: "nearest",
      inline: "start"
    });
  }, [visualFocusIndex]);

  var handleResize = function handleResize() {
    setStyles({
      width: getSelectWidth()
    });
  };

  (0, _react.useLayoutEffect)(function () {
    handleResize();
  }, [getSelectWidth]);
  (0, _react.useEffect)(function () {
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, [getSelectWidth]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.select
  }, /*#__PURE__*/_react["default"].createElement(ListboxContainer, {
    id: id,
    onClick: function onClick(event) {
      event.stopPropagation();
    },
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
    },
    ref: listboxRef,
    role: "listbox",
    "aria-multiselectable": multiple,
    style: styles
  }, searchable && (options.length === 0 || !groupsHaveOptions(options)) ? /*#__PURE__*/_react["default"].createElement(OptionsSystemMessage, null, /*#__PURE__*/_react["default"].createElement(NoMatchesFoundIcon, null, _Icons["default"].searchOff), translatedLabels.select.noMatchesErrorMessage) : optional && !multiple && /*#__PURE__*/_react["default"].createElement(_Option["default"], {
    key: "option-".concat(optionalItem.value),
    id: "option-".concat(0),
    option: optionalItem,
    onClick: handleOptionOnClick,
    multiple: multiple,
    visualFocused: visualFocusIndex === 0,
    isGroupedOption: false,
    isLastOption: lastOptionIndex === 0,
    isSelected: multiple ? currentValue.includes(optionalItem.value) : currentValue === optionalItem.value
  }), options.map(mapOptionFunc)));
};

var ListboxContainer = _styledComponents["default"].ul(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  box-sizing: border-box;\n  max-height: 304px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 0.25rem 0;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 0.25rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  cursor: default;\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n"])), function (props) {
  return props.theme.listDialogBackgroundColor;
}, function (props) {
  return props.theme.listDialogBorderColor;
}, function (props) {
  return props.theme.listOptionFontColor;
}, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.listOptionFontSize;
}, function (props) {
  return props.theme.listOptionFontStyle;
}, function (props) {
  return props.theme.listOptionFontWeight;
});

var OptionsSystemMessage = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  padding: 4px 16px;\n  color: ", ";\n  font-size: 0.875rem;\n  line-height: 1.715em;\n"])), function (props) {
  return props.theme.systemMessageFontColor;
});

var NoMatchesFoundIcon = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  height: 16px;\n  width: 16px;\n  padding: 4px;\n  margin-right: 0.25rem;\n"])));

var GroupList = _styledComponents["default"].ul(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 0;\n"])));

var GroupLabel = _styledComponents["default"].li(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 4px 16px;\n  font-weight: ", ";\n  line-height: 1.715em;\n"])), function (props) {
  return props.theme.listGroupLabelFontWeight;
});

var _default = /*#__PURE__*/_react["default"].memo(Listbox);

exports["default"] = _default;